import VrTourPopupInit from './partials/vr-tour-popup';

const dialog = document.querySelector('.gallery dialog');
const VrTourLink = Array.from(document.querySelectorAll('a'))
  .find((a) => a.textContent.trim() === 'VR Tour');

VrTourPopupInit(VrTourLink, dialog);
